// Effect-allele frequencies by 1000 Genomes superpopulation.
//
// Generated from Ensembl/1000G phase 3, then RECONCILED against the alleles in
// catalog.ts — which have been through two adversarial verification passes and
// are the more trustworthy source. 53 of 178 arrived with REF and ALT swapped
// relative to the catalog and were inverted to match; nothing was taken on
// trust. See scratchpad/freqcheck.mjs for the reconciliation.
//
// The number is the frequency of the CATALOG'S EFFECT ALLELE, not of the
// reference or the minor allele. That is the only framing that lets a sample
// generator draw a realistic genotype without re-deriving orientation.

export const SUPERPOPS = ['EUR', 'EAS', 'SAS', 'AFR', 'AMR'] as const;
export type Superpop = (typeof SUPERPOPS)[number];

export const SUPERPOP_LABELS: Record<Superpop, string> = {
  EUR: 'European',
  EAS: 'East Asian',
  SAS: 'South Asian',
  AFR: 'African',
  AMR: 'Admixed American',
};

/** rsID -> [effectAllele, [EUR, EAS, SAS, AFR, AMR]] */
export const EFFECT_FREQ: Record<string, [string, number[]]> = {
  rs1006737: ['A', [0.3161, 0.0506, 0.2382, 0.5386, 0.2824]],
  rs10088218: ['A', [0.1044, 0.0089, 0.1043, 0.118, 0.0893]],
  rs10166942: ['T', [0.826, 0.3671, 0.4969, 0.0976, 0.7003]],
  rs10246939: ['C', [0.4612, 0.6766, 0.362, 0.4766, 0.6873]],
  rs1042725: ['T', [0.5368, 0.8234, 0.6718, 0.3351, 0.6441]],
  rs10427255: ['C', [0.495, 0.4415, 0.4489, 0.413, 0.3732]],
  rs10455872: ['G', [0.0736, 0.005, 0.0061, 0.0023, 0.0331]],
  rs10483727: ['T', [0.4036, 0.7867, 0.5767, 0.966, 0.3415]],
  rs10484554: ['T', [0.1431, 0.0516, 0.1963, 0.084, 0.0836]],
  rs10488631: ['C', [0.1004, 0.002, 0.135, 0.0068, 0.0749]],
  rs10490770: ['C', [0.0805, 0.005, 0.2955, 0.0038, 0.0432]],
  rs10490924: ['T', [0.1948, 0.4038, 0.3425, 0.2458, 0.2478]],
  rs1049550: ['A', [0.4503, 0.6429, 0.3425, 0.1551, 0.4654]],
  rs1050828: ['T', [0, 0, 0, 0.1346, 0.0134]],
  rs1051730: ['A', [0.3688, 0.0268, 0.183, 0.087, 0.2161]],
  rs1057910: ['C', [0.0726, 0.0337, 0.1094, 0.0023, 0.0375]],
  rs1061170: ['C', [0.3618, 0.0486, 0.2873, 0.3623, 0.2334]],
  rs1061235: ['T', [0.0328, 0.1171, 0.1115, 0.0908, 0.0663]],
  rs1065852: ['A', [0.2018, 0.5714, 0.1646, 0.1127, 0.1484]],
  rs10741657: ['G', [0.6193, 0.6806, 0.6421, 0.7814, 0.7161]],
  rs10757278: ['G', [0.4742, 0.5437, 0.5041, 0.1589, 0.4553]],
  rs10917469: ['G', [0.1421, 0.131, 0.1084, 0.2557, 0.1945]],
  rs11031006: ['A', [0.1412, 0.0317, 0.0982, 0.0469, 0.0965]],
  rs11172113: ['T', [0.6213, 0.754, 0.6442, 0.5454, 0.464]],
  rs11203203: ['A', [0.3519, 0.0238, 0.2955, 0.1293, 0.2205]],
  rs11209026: ['A', [0.0616, 0, 0.0123, 0.003, 0.0519]],
  rs1126809: ['G', [0.7475, 0.999, 0.9458, 0.9909, 0.8746]],
  rs113851554: ['T', [0.0527, 0, 0.0276, 0.0045, 0.0216]],
  rs1142345: ['C', [0.0288, 0.0218, 0.0174, 0.0666, 0.0576]],
  rs1143679: ['A', [0.1312, 0.0149, 0.0593, 0.1203, 0.0893]],
  rs1160312: ['A', [0.5308, 0.3254, 0.4714, 0.2693, 0.3127]],
  rs116855232: ['T', [0.002, 0.0952, 0.0695, 0.0008, 0.0447]],
  rs11887534: ['C', [0.0795, 0.0139, 0.0419, 0.0764, 0.0965]],
  rs12203592: ['T', [0.1163, 0, 0.0061, 0.0083, 0.072]],
  rs12248560: ['T', [0.2237, 0.0149, 0.136, 0.2352, 0.1196]],
  rs12552: ['A', [0.4573, 0.3343, 0.3282, 0.4281, 0.3329]],
  rs12576775: ['G', [0.1869, 0.0774, 0.0624, 0.1021, 0.0879]],
  rs12593813: ['G', [0.6392, 0.375, 0.5337, 0.2466, 0.389]],
  rs1260326: ['T', [0.4105, 0.4812, 0.2004, 0.0938, 0.3617]],
  rs12740374: ['T', [0.2127, 0.0427, 0.2587, 0.2474, 0.2046]],
  rs12785878: ['G', [0.2992, 0.62, 0.8487, 0.8298, 0.5504]],
  rs12913832: ['G', [0.6362, 0.002, 0.0706, 0.028, 0.2017]],
  rs12917707: ['T', [0.2008, 0.0129, 0.1411, 0.0227, 0.1571]],
  rs12979860: ['C', [0.6909, 0.9196, 0.7669, 0.3306, 0.6009]],
  rs1333040: ['T', [0.5736, 0.7044, 0.6084, 0.6415, 0.513]],
  rs1333049: ['C', [0.4722, 0.5367, 0.4908, 0.2133, 0.4553]],
  rs1342326: ['C', [0.165, 0.002, 0.1391, 0.3464, 0.1398]],
  rs13429458: ['A', [0.8668, 0.8006, 0.8057, 0.8011, 0.9063]],
  rs1344706: ['A', [0.6223, 0.4831, 0.6534, 0.9599, 0.6657]],
  rs1378942: ['C', [0.3867, 0.8175, 0.8395, 0.9735, 0.6657]],
  rs1432639: ['A', [0.6412, 0.9335, 0.6207, 0.3033, 0.683]],
  rs143384: ['A', [0.5885, 0.7113, 0.4059, 0.0272, 0.6571]],
  rs1447295: ['A', [0.1024, 0.1419, 0.1268, 0.3502, 0.1066]],
  rs1625579: ['T', [0.7893, 0.9296, 0.7771, 0.6694, 0.8862]],
  rs16891982: ['G', [0.9384, 0.006, 0.0593, 0.0356, 0.464]],
  rs16969968: ['A', [0.3658, 0.0268, 0.182, 0.0234, 0.2089]],
  rs17249754: ['G', [0.8559, 0.6865, 0.6554, 0.8691, 0.8876]],
  rs1726866: ['G', [0.4612, 0.6756, 0.362, 0.6672, 0.7147]],
  rs17319721: ['A', [0.4115, 0.0893, 0.1278, 0.1861, 0.3545]],
  rs17646946: ['A', [0.2425, 0.002, 0.1002, 0.1097, 0.1124]],
  rs17728338: ['A', [0.0696, 0.1042, 0.1534, 0.1029, 0.049]],
  rs17782313: ['C', [0.2396, 0.1865, 0.32, 0.2776, 0.134]],
  rs17822931: ['T', [0.1362, 0.7798, 0.4816, 0.0121, 0.1398]],
  rs179247: ['A', [0.503, 0.6052, 0.4254, 0.851, 0.572]],
  rs1799853: ['T', [0.1243, 0.001, 0.0348, 0.0083, 0.0994]],
  rs1799945: ['G', [0.172, 0.0288, 0.0706, 0.0113, 0.1153]],
  rs1799963: ['A', [0.008, 0, 0, 0, 0.0144]],
  rs1800407: ['T', [0.0755, 0.001, 0.0266, 0.0015, 0.0317]],
  rs1800460: ['T', [0.0278, 0, 0.0041, 0.003, 0.0403]],
  rs1800562: ['A', [0.0427, 0, 0.002, 0.0023, 0.0216]],
  rs1801131: ['G', [0.3131, 0.2192, 0.4172, 0.1513, 0.1513]],
  rs1801133: ['A', [0.3648, 0.2956, 0.1186, 0.09, 0.4741]],
  rs1801222: ['A', [0.2893, 0.1528, 0.1677, 0.1944, 0.2003]],
  rs1801282: ['C', [0.8797, 0.9742, 0.8804, 0.9947, 0.8833]],
  rs1805007: ['T', [0.0716, 0.001, 0.0051, 0.003, 0.0159]],
  rs1805008: ['T', [0.0616, 0, 0.0041, 0.0038, 0.0029]],
  rs1805009: ['C', [0.008, 0, 0, 0.0015, 0.0101]],
  rs1815739: ['T', [0.4344, 0.4435, 0.5869, 0.115, 0.572]],
  rs1835740: ['T', [0.2217, 0.6181, 0.4294, 0.2549, 0.2233]],
  rs1837253: ['C', [0.7475, 0.3938, 0.5399, 0.6876, 0.732]],
  rs1990760: ['T', [0.6054, 0.1865, 0.5644, 0.1256, 0.3905]],
  rs20541: ['A', [0.2068, 0.3601, 0.272, 0.1899, 0.3804]],
  rs2066844: ['T', [0.0507, 0, 0.001, 0.0023, 0.0245]],
  rs2076530: ['T', [0.5527, 0.7083, 0.5654, 0.6725, 0.5159]],
  rs2107595: ['A', [0.168, 0.3581, 0.3139, 0.2103, 0.2161]],
  rs2155219: ['T', [0.4911, 0.5268, 0.5174, 0.5923, 0.5043]],
  rs2187668: ['T', [0.1064, 0.0516, 0.0787, 0.0537, 0.1182]],
  rs2200733: ['T', [0.1551, 0.4514, 0.1309, 0.2315, 0.2767]],
  rs2231142: ['T', [0.0944, 0.2907, 0.0971, 0.0129, 0.1412]],
  rs2282679: ['G', [0.2465, 0.2609, 0.2965, 0.0499, 0.2089]],
  rs2294008: ['T', [0.4473, 0.3423, 0.407, 0.3676, 0.5043]],
  rs2300478: ['G', [0.2475, 0.2897, 0.273, 0.1127, 0.2161]],
  rs2395029: ['G', [0.0437, 0.0119, 0.093, 0.0045, 0.0202]],
  rs2476601: ['A', [0.0944, 0, 0.0133, 0.003, 0.036]],
  rs2479106: ['G', [0.2962, 0.1835, 0.3027, 0.8238, 0.2954]],
  rs2651899: ['C', [0.4254, 0.4117, 0.5051, 0.7345, 0.4928]],
  rs2736100: ['C', [0.499, 0.4147, 0.6053, 0.4675, 0.428]],
  rs28371725: ['T', [0.0934, 0.0377, 0.1217, 0.0182, 0.062]],
  rs2858884: ['A', [0.8072, 0.9355, 0.7699, 0.6596, 0.853]],
  rs2941740: ['G', [0.4404, 0.1022, 0.2117, 0.3495, 0.3718]],
  rs2981582: ['A', [0.4205, 0.3165, 0.3436, 0.4947, 0.4179]],
  rs30187: ['T', [0.3499, 0.4534, 0.409, 0.4024, 0.4049]],
  rs3024505: ['A', [0.168, 0.0278, 0.1391, 0.0318, 0.0821]],
  rs3087243: ['G', [0.5298, 0.7371, 0.3732, 0.8238, 0.6196]],
  rs3118470: ['C', [0.3241, 0.4931, 0.41, 0.1263, 0.2939]],
  rs3135388: ['A', [0.1203, 0.006, 0.0174, 0.0272, 0.0504]],
  rs3184504: ['T', [0.4642, 0.003, 0.0685, 0.0189, 0.2536]],
  rs328: ['G', [0.1302, 0.122, 0.0859, 0.0613, 0.0634]],
  rs334: ['A', [0, 0, 0, 0.0998, 0.0072]],
  rs33980500: ['T', [0.0855, 0.004, 0.0583, 0.143, 0.1196]],
  rs356219: ['G', [0.3857, 0.5238, 0.4243, 0.6936, 0.4467]],
  rs3736228: ['T', [0.1342, 0.2034, 0.1074, 0.0219, 0.1542]],
  rs3790567: ['A', [0.2435, 0.247, 0.226, 0.7897, 0.3199]],
  rs3798220: ['C', [0.0099, 0.0883, 0.002, 0.0045, 0.2161]],
  rs3801387: ['G', [0.2634, 0.121, 0.228, 0.4054, 0.2248]],
  rs38055: ['A', [0.3052, 0.2649, 0.3139, 0.0613, 0.2954]],
  rs3814113: ['C', [0.3062, 0.2698, 0.4448, 0.615, 0.5692]],
  rs3827760: ['G', [0.0109, 0.873, 0.0133, 0.003, 0.3919]],
  rs3892097: ['T', [0.1859, 0.002, 0.1094, 0.0605, 0.1297]],
  rs3918290: ['T', [0.005, 0, 0.0082, 0.0008, 0.0014]],
  rs3923809: ['A', [0.6899, 0.3661, 0.5665, 0.7201, 0.6527]],
  rs4149056: ['C', [0.161, 0.123, 0.0429, 0.0136, 0.134]],
  rs4244285: ['A', [0.1451, 0.3125, 0.3579, 0.1702, 0.1052]],
  rs4245791: ['T', [0.6899, 0.996, 0.7935, 0.8933, 0.8026]],
  rs429358: ['C', [0.1551, 0.0863, 0.0869, 0.2678, 0.1037]],
  rs4349859: ['A', [0.0467, 0.001, 0.0082, 0.0023, 0.013]],
  rs4481887: ['A', [0.2773, 0.1379, 0.1022, 0.0998, 0.2176]],
  rs454214: ['T', [0.5586, 0.6081, 0.5603, 0.171, 0.4006]],
  rs4656461: ['G', [0.1412, 0.0089, 0.0429, 0.2564, 0.1354]],
  rs4704397: ['A', [0.4046, 0.8244, 0.6002, 0.8722, 0.5937]],
  rs478304: ['T', [0.5338, 0.5308, 0.2699, 0.5961, 0.67]],
  rs479844: ['G', [0.5567, 0.2679, 0.5389, 0.1657, 0.3314]],
  rs485499: ['T', [0.6511, 0.8641, 0.8252, 0.9312, 0.7867]],
  rs4939827: ['T', [0.5318, 0.3105, 0.2812, 0.3048, 0.3501]],
  rs4977756: ['A', [0.6004, 0.7946, 0.726, 0.68, 0.7925]],
  rs4988235: ['A', [0.508, 0, 0.1135, 0.0272, 0.2161]],
  rs505922: ['C', [0.3678, 0.381, 0.3926, 0.3654, 0.219]],
  rs5219: ['T', [0.3529, 0.3383, 0.3957, 0.0234, 0.2925]],
  rs58542926: ['T', [0.0676, 0.0863, 0.1074, 0.0227, 0.0634]],
  rs6010620: ['G', [0.7942, 0.2927, 0.7321, 0.972, 0.7118]],
  rs601338: ['A', [0.4414, 0.004, 0.2832, 0.4909, 0.3415]],
  rs6025: ['T', [0.0119, 0, 0.0112, 0, 0.0101]],
  rs602662: ['A', [0.4682, 0.004, 0.2832, 0.4924, 0.3516]],
  rs6152: ['G', [0.8577, 0.9974, 0.9067, 0.35, 0.8645]],
  rs61816761: ['A', [0.0099, 0, 0.001, 0.0015, 0.0058]],
  rs6511720: ['T', [0.1103, 0.0119, 0.0787, 0.1467, 0.0937]],
  rs671: ['A', [0, 0.1736, 0, 0.0015, 0.0029]],
  rs67376798: ['A', [0.007, 0, 0.001, 0.0008, 0.0029]],
  rs6841581: ['G', [0.8539, 0.7718, 0.7863, 0.6989, 0.8372]],
  rs6927022: ['A', [0.6074, 0.6349, 0.6851, 0.7201, 0.4957]],
  rs693: ['A', [0.4423, 0.0615, 0.2157, 0.2095, 0.3775]],
  rs6983267: ['G', [0.499, 0.3879, 0.5317, 0.9523, 0.5504]],
  rs7025486: ['A', [0.2177, 0.2837, 0.3436, 0.326, 0.2277]],
  rs713598: ['G', [0.4225, 0.6756, 0.3446, 0.475, 0.6585]],
  rs7216389: ['T', [0.4841, 0.7113, 0.6309, 0.823, 0.6282]],
  rs72921001: ['A', [0.3569, 0.3135, 0.4254, 0.2073, 0.3732]],
  rs738409: ['G', [0.2256, 0.3502, 0.2464, 0.118, 0.4841]],
  rs73885319: ['G', [0, 0, 0, 0.2595, 0.0086]],
  rs7412: ['T', [0.0626, 0.1002, 0.044, 0.1029, 0.0476]],
  rs755383: ['T', [0.6203, 0.6468, 0.593, 0.3533, 0.5548]],
  rs7574865: ['T', [0.2296, 0.3472, 0.2996, 0.1165, 0.3617]],
  rs762551: ['C', [0.3201, 0.3274, 0.4652, 0.438, 0.2421]],
  rs776746: ['T', [0.0567, 0.2867, 0.3323, 0.82, 0.2032]],
  rs7903146: ['T', [0.3171, 0.0228, 0.2986, 0.2602, 0.2349]],
  rs7927894: ['T', [0.3738, 0.2143, 0.2996, 0.3472, 0.2392]],
  rs8032158: ['C', [0.2803, 0.3036, 0.4315, 0.3154, 0.2997]],
  rs8099917: ['T', [0.832, 0.9236, 0.8333, 0.9576, 0.7233]],
  rs9263726: ['A', [0.1501, 0.0625, 0.0501, 0.1626, 0.1196]],
  rs9298506: ['A', [0.828, 0.7917, 0.7689, 0.8306, 0.8602]],
  rs944289: ['T', [0.5815, 0.4613, 0.4632, 0.1528, 0.379]],
  rs9543325: ['C', [0.3897, 0.4276, 0.3395, 0.9478, 0.4308]],
  rs964184: ['G', [0.162, 0.2401, 0.229, 0.2209, 0.2767]],
  rs9642880: ['T', [0.4493, 0.3135, 0.5838, 0.8079, 0.4294]],
  rs965513: ['A', [0.337, 0.129, 0.1871, 0.1067, 0.3026]],
  rs9834970: ['C', [0.5109, 0.5804, 0.5409, 0.3079, 0.5432]],
  rs9923231: ['T', [0.3877, 0.8849, 0.1452, 0.0545, 0.4107]],
  rs9939609: ['A', [0.4135, 0.1687, 0.2883, 0.4939, 0.2622]],
  rs995030: ['G', [0.7992, 0.7321, 0.7873, 0.2511, 0.8329]],
};

/** Frequency of `rsid`'s effect allele in `pop`, or null if unknown. */
export function effectFreq(rsid: string, pop: Superpop): number | null {
  const e = EFFECT_FREQ[rsid.toLowerCase()] ?? EFFECT_FREQ[rsid];
  if (!e) return null;
  const i = SUPERPOPS.indexOf(pop);
  return i < 0 ? null : e[1][i];
}
